import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationDemographicConfigsNotFoundError =
  BaseErrorSchema.extend({
    errorType: z.literal('OrganizationDemographicConfigsNotFoundError'),
  });

export type OrganizationDemographicConfigsNotFoundError = z.infer<
  typeof OrganizationDemographicConfigsNotFoundError
>;
